import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@webapp/assets/tree-crossing-icon-256.png'


const _withScopeId = n => (_pushScopeId("data-v-1cb20482"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "brand"
}
const _hoisted_3 = {
  key: 2,
  class: "instruction"
}
const _hoisted_4 = { class: "task-body" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "secondary-action" }
const _hoisted_7 = ["disabled"]

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAppHostStore } from '@webapp/AppHostStore'
import Spinner from './Spinner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TaskPage',
  props: {
    noTitle: { type: Boolean },
    noBrand: { type: Boolean },
    noBack: { type: Boolean },
    noAutoBack: { type: Boolean },
    noAction: { type: Boolean },
    canContinue: { type: Boolean }
  },
  emits: ['action', 'back'],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;



const appHostStore = useAppHostStore()



const router = useRouter()

const busyRef = ref(false)

function onAction(e: Event) {
  e.preventDefault()
  busyRef.value = true
  emit('action')
}

function onBack() {
  // Always let a parent react to Back; by default we also step back in history,
  // unless the parent opts out (e.g. a wizard that manages its own steps).
  emit('back')
  if (!props.noAutoBack) {
    router.back()
  }
}

function setBusy(value: boolean) {
  busyRef.value = value
}

__expose({ setBusy })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["task-page container", { embedded: _unref(appHostStore).isEmbedded }])
  }, [
    (!props.noTitle)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, [
          (!props.noBrand)
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "title")
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.alert)
      ? _renderSlot(_ctx.$slots, "alert", { key: 1 })
      : _createCommentVNode("", true),
    (_ctx.$slots.instruction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "instruction")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "secondaryAction")
        ]),
        (!props.noBack)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-outline-primary",
              onClick: onBack
            }, [
              _renderSlot(_ctx.$slots, "backText", {}, () => [
                _createTextVNode("Back")
              ])
            ]))
          : _createCommentVNode("", true),
        (!props.noAction)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "submit",
              class: "btn btn-primary",
              disabled: busyRef.value || !props.canContinue,
              onClick: onAction
            }, [
              (busyRef.value)
                ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "actionText", {}, () => [
                _createTextVNode(" Next ")
              ])
            ], 8, _hoisted_7))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})